import { useMemo } from 'react';
import { Button } from '@givebutter/primitives/button';
import { pluralize } from '@givebutter/util';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDonorSearchIntegration } from 'assets/js/pages/contacts/single/donor-search/useDonorSearchIntegration';
import { usePerformDonorSearch } from 'assets/js/pages/contacts/single/donor-search/usePerformDonorSearch';
import { useCurrentContact } from 'customHooks/useCurrentContact';

const Unsearched = () => {
    const { data: contact } = useCurrentContact();
    const { data: integration } = useDonorSearchIntegration();
    const { mutateAsync: search, isPending: isSearchPending } = usePerformDonorSearch();

    const missingFields = useMemo(() => {
        return [
            { name: 'first name', value: contact.first_name },
            { name: 'last name', value: contact.last_name },
            { name: 'state', value: contact.primary_address?.state },
        ].filter(f => {
            return f.value === null || typeof f.value === 'undefined';
        });
    }, [contact]);

    const fewRemainingCalls = useMemo(() => {
        const stats = integration?.mapping?.data;

        if (
            typeof stats?.ApiSearchMonthlyLimit === 'undefined' ||
            Number(stats?.ApiSearchMonthlyLimit) === 0
        ) {
            return false;
        }

        return Number(stats?.ApiSearchMonthlyLimit) - Number(stats?.ApiSearchesThisMonth) < 10;
    }, [integration]);

    return (
        <div className="relative flex flex-grow flex-col justify-center gap-2">
            <img
                alt="DonorSearch"
                src="/images/logos/donorsearch.svg"
                className="w-full max-w-48"
            />

            <p className="w-full max-w-prose text-center text-sm">
                Use DonorSearch’s Wealth Screening tool to enrich data for this Contact based on
                their capacity and likelihood to give.
            </p>

            {missingFields.length > 0 && (
                <p className="w-full max-w-prose text-center text-sm text-red-500">
                    <span>
                        This contact is missing the{' '}
                        <u>{missingFields.map(f => f.name).join(', ')}</u>{' '}
                        {pluralize(missingFields.length, 'field')} required for performing the
                        search.
                    </span>
                </p>
            )}

            <Button
                disabled={isSearchPending || missingFields.length > 0}
                variant="solid"
                color="primary"
                onClick={() => search(false)}
            >
                {isSearchPending ? <FontAwesomeIcon icon={faSpinnerThird} spin /> : 'Run Search'}
            </Button>

            {fewRemainingCalls && (
                <p className="text-center text-sm text-orange-700">
                    You're running low on API calls—visit your DonorSearch account to increase your
                    limit.
                </p>
            )}
        </div>
    );
};

export default Unsearched;
